export const version = '2.11.15';
//# sourceMappingURL=version.js.map